import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocationForSelection } from 'src/app/core/auth/auth.interface';
import { environment } from 'src/environments/environment';

export interface LocationSelectionData {
  locations: LocationForSelection[];
  title?: string;
  message?: string;
  afterLogin?: boolean;
}

export interface LocationSelectionResult {
  locationId: number;
}

@Component({
  selector: 'app-location-selection-dialog',
  templateUrl: './location-selection-dialog.component.html',
  styleUrls: ['./location-selection-dialog.component.scss'],
})
export class LocationSelectionDialogComponent implements OnInit {
  selectedLocationId: number | null = null;
  imagenSerUrl = environment.url_media;

  public readonly dialogRef = inject(MatDialogRef<LocationSelectionDialogComponent>);
  public readonly data = inject<LocationSelectionData>(MAT_DIALOG_DATA);

  ngOnInit(): void { }

  selectLocation(locationId: number): void {
    this.selectedLocationId = locationId;
    this.dialogRef.close({ locationId });
  }

  getLocationDisplayName(location: LocationForSelection): string {
    const parts = [location.title];
    if (location.city) parts.push(location.city);
    if (location.state) parts.push(location.state);
    return parts.join(', ');
  }

  getLocationAvatarUrl(avatar: string | null | undefined): string | null {
    if (!avatar) {
      return null;
    }

    // If avatar is already a full URL, return it as-is
    if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
      return avatar;
    }

    // Construct full URL using backend media/storage path
    // url_media already includes /storage/ so just append the avatar path
    return `${environment.url_media}${avatar}`;
  }
}
